// extracted by mini-css-extract-plugin
export var aggregationCell = "_2k-f";
export var aggregationRow = "_2k-e";
export var borderlessSpinnerContainer = "_2k-2";
export var closeIcon = "_2k-7";
export var expandIcon = "_2k-8";
export var expanded = "_2k-9";
export var filterDropdown = "_2k-a";
export var filterDropdownDivider = "_2k-5";
export var filterDropdownHeader = "_2k-d";
export var filterDropdownItem = "_2k-c";
export var filterDropdownModal = "_2k-b _2k-a";
export var filterItem = "_2k-4";
export var normalCellWithAdjustableBorder = "_2k-6";
export var pinButtonContainer = "_2k-g";
export var pinIcon = "_2k-h";
export var pinIconActive = "_2k-i";
export var spinner = "_2k-0";
export var spinnerContainer = "_2k-1";
export var tableContainer = "_2k-3";
export var viewButtonContainer = "_2k-j";